import React, { Component } from "react";
import { Button } from "react-bootstrap";
import imgCamelLogo from '../../assets/images/main-logo-white.png';
import "./DeleteConfirmForm.scss";

class DomainAcceptConfirmForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAcceptable: false
    }
  }

  render() {
    return (
      <div className="delete-confirm-form">
        <div className="form-header">
          <img src={imgCamelLogo} alt="logo" />
        </div>
        <div className="user-container d-flex flex-column align-items-center p-4">
          <div className="delete-question d-flex align-items-center">
            <input
              type="checkbox"
              checked={this.state.isAcceptable} onChange={e => this.setState({ isAcceptable: !this.state.isAcceptable })}
              className="mr-2"
            />
            Are you sure you want to change short domain?
          </div>
          <div className="actions-box mt-4">
            <Button variant="outline-danger" className="mr-2" size="sm" onClick={this.props.onClose}>CANCEL</Button>
            <Button
              variant="outline-danger"
              className="mr-2"
              size="sm"
              onClick={this.props.onConfirm}
              disabled={!this.state.isAcceptable}
            >
              ACCEPT
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default DomainAcceptConfirmForm;
